import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GET, POST, DELETE, httpOk } from 'helpers/api'

function Index() {
	const { t } = useTranslation()

	const [apiUrl, setApiUrl]           = useState('')
	const [apiKey, setApiKey]           = useState('')
	const [isActive, setIsActive]       = useState(false)
	const [saving, setSaving]           = useState(false)
	const [testing, setTesting]         = useState(false)
	const [saveStatus, setSaveStatus]   = useState(null)
	const [testStatus, setTestStatus]   = useState(null)
	const [testMessage, setTestMessage] = useState('')

	// --- CRM O'QISH kaliti (tashqi CRM ERP dan ma'lumot oladi) ---
	const [readKey, setReadKey]         = useState('')
	const [baseUrl, setBaseUrl]         = useState('')
	const [allowedIps, setAllowedIps]   = useState('')
	const [keyBusy, setKeyBusy]         = useState(false)
	const [copied, setCopied]           = useState(false)
	const [showKey, setShowKey]         = useState(false)

	useEffect(() => {
		loadSettings()
		loadReadKey()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	async function loadSettings() {
		const res = await GET('/crm-settings', {}, { loader: true })
		if (httpOk(res)) {
			setApiUrl(res.data?.api_url || '')
			setApiKey(res.data?.api_key || '')
			setIsActive(!!res.data?.is_active)
		}
	}

	async function loadReadKey() {
		const res = await GET('/crm-settings/read-key', {}, { loader: false })
		if (httpOk(res)) {
			setReadKey(res.data?.read_key || '')
			setBaseUrl(res.data?.base_url || '')
			setAllowedIps(res.data?.allowed_ips || '')
		}
	}

	async function regenerateKey() {
		// Eski kalit DARHOL ishlamay qoladi — CRM'da yangisini qo'yish kerak
		if (readKey && !window.confirm(t('crm_read_key_confirm'))) return
		setKeyBusy(true)
		const res = await POST('/crm-settings/read-key', {}, { loader: false })
		setKeyBusy(false)
		if (httpOk(res)) {
			setReadKey(res.data?.read_key || '')
			setShowKey(true)
		}
	}

	async function revokeKey() {
		if (!window.confirm(t('crm_read_key_revoke_confirm'))) return
		setKeyBusy(true)
		const res = await DELETE('/crm-settings/read-key', {}, { loader: false })
		setKeyBusy(false)
		if (httpOk(res)) setReadKey('')
	}

	async function saveIps() {
		setKeyBusy(true)
		await POST('/crm-settings/allowed-ips', { allowed_ips: allowedIps }, { loader: false })
		setKeyBusy(false)
	}

	function copyKey() {
		navigator.clipboard?.writeText(readKey)
		setCopied(true)
		setTimeout(() => setCopied(false), 2000)
	}

	async function saveSettings(e) {
		e.preventDefault()
		setSaving(true)
		setSaveStatus(null)
		setIsActive(false)
		const res = await POST('/crm-settings', { api_url: apiUrl, api_key: apiKey }, { loader: false })
		setSaving(false)
		if (httpOk(res)) {
			setSaveStatus('ok')
			setTimeout(() => setSaveStatus(null), 3000)
		} else {
			setSaveStatus('err')
		}
	}

	async function testConnection(e) {
		e.preventDefault()
		setTesting(true)
		setTestStatus(null)
		setTestMessage('')
		const res = await POST('/crm-settings/test', {}, { loader: false })
		setTesting(false)
		if (httpOk(res)) {
			setTestStatus('ok')
			setIsActive(true)
			setTestMessage(t('crm_test_success'))
		} else {
			setTestStatus('err')
			setIsActive(false)
			setTestMessage(res?.data?.message || t('crm_test_failed'))
		}
	}

	const hasCredentials = apiUrl.trim() && apiKey.trim()

	return (
		<>
			<div className="page-header d-flex justify-content-between align-items-center">
				<h4 className="vertical-center mb-0">
					{t('crm_integration')}
				</h4>
				{isActive && (
					<span className="badge bg-success fs-6 px-3 py-2">
						<i className="uil uil-check-circle me-1"></i>
						{t('crm_connected')}
					</span>
				)}
				{!isActive && hasCredentials && (
					<span className="badge bg-warning text-dark fs-6 px-3 py-2">
						<i className="uil uil-exclamation-triangle me-1"></i>
						{t('crm_not_tested')}
					</span>
				)}
			</div>

			<div className="row">
				<div className="col-md-7 col-lg-6">

					{/* API credentials */}
					<div className="card mb-3">
						<div className="card-body">
							<h6 className="fw-bold mb-3">
								<i className="uil uil-key-skeleton-alt me-2 text-primary"></i>
								{t('crm_credentials')}
							</h6>

							<form onSubmit={saveSettings} autoComplete="off">
								<div className="form-group mb-3">
									<label className="form-label">{t('crm_api_url')}</label>
									<input
										type="url"
										className="form-control font-monospace"
										placeholder="https://crm.example.com/api"
										value={apiUrl}
										onChange={e => setApiUrl(e.target.value)}
										style={{ fontSize: '13px' }}
									/>
									<div className="form-text">{t('crm_url_hint')}</div>
								</div>

								<div className="form-group mb-3">
									<label className="form-label">{t('crm_api_key')}</label>
									<input
										type="password"
										className="form-control font-monospace"
										placeholder="••••••••••••••••••••"
										value={apiKey}
										onChange={e => {
											setApiKey(e.target.value)
											setIsActive(false)
										}}
										style={{ fontSize: '13px', letterSpacing: '2px' }}
									/>
									<div className="form-text">{t('crm_key_hint')}</div>
								</div>

								{saveStatus === 'ok' && (
									<div className="alert alert-success py-2 mb-2" style={{ fontSize: '13px' }}>
										<i className="uil uil-check me-1"></i> {t('saved')}
									</div>
								)}
								{saveStatus === 'err' && (
									<div className="alert alert-danger py-2 mb-2" style={{ fontSize: '13px' }}>
										<i className="uil uil-exclamation-triangle me-1"></i> {t('crm_save_error')}
									</div>
								)}

								<button
									type="submit"
									className="btn btn-primary"
									disabled={saving || !hasCredentials}>
									{saving
										? <><span className="spinner-border spinner-border-sm me-2"></span>{t('saving')}</>
										: <><i className="uil uil-save me-1"></i>{t('save')}</>}
								</button>
							</form>
						</div>
					</div>

					{/* Test connection */}
					<div className="card mb-3">
						<div className="card-body">
							<h6 className="fw-bold mb-3">
								<i className="uil uil-wifi me-2 text-primary"></i>
								{t('crm_test_title')}
							</h6>

							<p className="text-muted mb-3" style={{ fontSize: '13px' }}>
								{t('crm_test_desc')}
							</p>

							{testStatus === 'ok' && (
								<div className="alert alert-success py-2 mb-3" style={{ fontSize: '13px' }}>
									<i className="uil uil-check-circle me-1"></i> {testMessage}
								</div>
							)}
							{testStatus === 'err' && (
								<div className="alert alert-danger py-2 mb-3" style={{ fontSize: '13px' }}>
									<i className="uil uil-exclamation-triangle me-1"></i> {testMessage}
								</div>
							)}

							<button
								className="btn btn-outline-primary"
								onClick={testConnection}
								disabled={testing || !hasCredentials}>
								{testing
									? <><span className="spinner-border spinner-border-sm me-2"></span>{t('crm_testing')}</>
									: <><i className="uil uil-plug me-1"></i>{t('crm_test_btn')}</>}
							</button>
						</div>
					</div>

					{/* Info */}
					<div className="card border-0" style={{ background: '#f8f9fa' }}>
						<div className="card-body py-3">
							<p className="mb-0 text-muted" style={{ fontSize: '13px' }}>
								<i className="uil uil-info-circle me-1 text-primary"></i>
								{t('crm_info')}
							</p>
						</div>
					</div>

				</div>

				{/* =========================================================
				    CRM UCHUN KALIT — TESKARI yo'nalish: tashqi CRM ERP dan
				    ma'lumot O'QIYDI. Yuqoridagi bloklar esa ERP dan CRM ga
				    yuborish uchun. Ikkalasi bir-biriga bog'liq emas.
				    ========================================================= */}
				<div className="col-md-5 col-lg-6">
					<div className="card mb-3">
						<div className="card-body">
							<h6 className="fw-bold mb-1">
								<i className="uil uil-import me-2 text-primary"></i>
								{t('crm_read_title')}
							</h6>
							<p className="text-muted mb-3" style={{ fontSize: '13px' }}>
								{t('crm_read_desc')}
							</p>

							{readKey ? (
								<>
									<label className="form-label">{t('crm_read_key')}</label>
									<div className="input-group mb-2">
										<input
											type={showKey ? 'text' : 'password'}
											className="form-control font-monospace"
											value={readKey}
											readOnly
											style={{ fontSize: '12px' }}
										/>
										<button className="btn btn-outline-secondary" type="button"
											onClick={() => setShowKey(!showKey)} title={t('show')}>
											<i className={showKey ? 'uil uil-eye-slash' : 'uil uil-eye'}></i>
										</button>
										<button className="btn btn-outline-primary" type="button" onClick={copyKey}>
											<i className="uil uil-copy me-1"></i>
											{copied ? t('copied') : t('copy')}
										</button>
									</div>

									<label className="form-label mt-2">{t('crm_read_url')}</label>
									<input className="form-control font-monospace mb-3" readOnly
										value={baseUrl} style={{ fontSize: '12px' }} />

									<div className="alert alert-light border py-2 mb-3" style={{ fontSize: '12px' }}>
										<div className="fw-bold mb-1">{t('crm_read_endpoints')}</div>
										<code className="d-block">GET {baseUrl}/ping</code>
										<code className="d-block">GET {baseUrl}/clients</code>
										<code className="d-block">GET {baseUrl}/cheques</code>
										<code className="d-block">GET {baseUrl}/cheque-products</code>
										<code className="d-block">GET {baseUrl}/references</code>
										<div className="mt-2 text-muted">{t('crm_read_header')}: <code>X-CRM-Key</code></div>
									</div>

									<label className="form-label">{t('crm_allowed_ips')}</label>
									<div className="input-group mb-1">
										<input className="form-control font-monospace" value={allowedIps}
											onChange={e => setAllowedIps(e.target.value)}
											placeholder="1.2.3.4, 5.6.7.8" style={{ fontSize: '12px' }} />
										<button className="btn btn-outline-secondary" type="button"
											onClick={saveIps} disabled={keyBusy}>{t('save')}</button>
									</div>
									<div className="form-text mb-3">{t('crm_allowed_ips_hint')}</div>

									<button className="btn btn-outline-secondary me-2" onClick={regenerateKey} disabled={keyBusy}>
										<i className="uil uil-refresh me-1"></i>{t('crm_read_key_new')}
									</button>
									<button className="btn btn-outline-danger" onClick={revokeKey} disabled={keyBusy}>
										<i className="uil uil-times me-1"></i>{t('crm_read_key_revoke')}
									</button>
								</>
							) : (
								<>
									<div className="alert alert-warning py-2 mb-3" style={{ fontSize: '13px' }}>
										<i className="uil uil-info-circle me-1"></i>{t('crm_read_no_key')}
									</div>
									<button className="btn btn-primary" onClick={regenerateKey} disabled={keyBusy}>
										{keyBusy
											? <><span className="spinner-border spinner-border-sm me-2"></span>{t('saving')}</>
											: <><i className="uil uil-key-skeleton-alt me-1"></i>{t('crm_read_key_create')}</>}
									</button>
								</>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Index
